
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import selectTime from "@/components/select-time/select-time.vue";
import carBrandAdd from "./car-brand-add.vue";

import { objAny } from "@/common/common-interface";
import { getCarBrandlist, delCarBrandtemUpgrade } from "@/api/api-car";
import i18n from "@/config/i18n";

@Component({
  components: { "select-time": selectTime, "cs-add-box": carBrandAdd }
})
export default class SystemConfigLog extends Vue {
  @Prop({ default: "" }) private tabName!: string;
  @Prop({ default: "" }) private activeTab!: string;
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    startTime: "",
    endTime: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    model: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("car.brand"), // Assuming "timeSubmitted" is the key for "Time Submitted"
      key: "brand",
      minWidth: 80
    },
    {
      title: i18n.t("car.series"), // Assuming "serial" is the key for "Serial"
      key: "serial",
      sortable: true,
      minWidth: 120
    },
    {
      title: i18n.t("car.model"), // Assuming "model" is the key for "Model"
      key: "model",
      minWidth: 180
    },
    {
      title: i18n.t("car.region"), // Assuming "region" is the key for "Region"
      key: "region",
      minWidth: 180
    },
    {
      title: i18n.t("car.powerMode"), // Assuming "powerMode" is the key for "Power Mode"
      key: "fuelType",
      sortable: true,
      minWidth: 140
    },
    {
      title: i18n.t("car.rank"), // Assuming "rank" is the key for "Rank"
      key: "carRank",
      minWidth: 100
    },
    {
      title: i18n.t("car.seats"), // Assuming "seats" is the key for "Seats"
      key: "seats",
      minWidth: 100
    },
    {
      title: i18n.t("car.batteryCapacity"), // Assuming "batteryCapacity" is the key for "Battery (kWh)"
      key: "capacity",
      minWidth: 100
    },
    {
      title: i18n.t("car.mileage"), // Assuming "mileage" is the key for "Mileage(km)"
      key: "rechargeMileage",
      minWidth: 100
    },
    {
      title: i18n.t("car.timeSubmitted"), // Assuming "createDate" is the key for "Create Date"
      key: "createTime",
      minWidth: 100
    },
    {
      title: i18n.t("car.users"), // Assuming "users" is the key for "Users"
      key: "userCarCount",
      minWidth: 100
    },
    {
      title: i18n.t("audit.action"), // Assuming "action" is the key for "Action"
      key: "action",
      minWidth: 130,
      slot: "action"
    }
  ];

  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    //this.getTableList();
  }

  public addNewCarDirectory(): void {
    const addbox: objAny = this.$refs["addbox"];
    addbox.open({}, "add");
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }

  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }

  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getCarBrandlist(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }

  public init(newVal: string): void {
    if (newVal === this.tabName && this.tableList.length === 0) {
      this.getTableList();
    }
  }

  async delItemClick(item: objAny): Promise<void> {
    const ret = await delCarBrandtemUpgrade({
      id: item.id
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }

  public editClick(item: objAny) {
    const addbox: objAny = this.$refs["addbox"];
    addbox.open(item);
  }

  @Watch("activeTab")
  getVisible(newVal: string) {
    this.init(newVal);
  }

  mounted() {
    //
    this.init(this.activeTab);
  }
}
